<template>
    <div class="relative flex justify-end items-center">
        <div @click="changeContentState" class="z-10 fixed w-screen h-screen right-0 top-0 opacity-50" ></div>
        <div class="fadeInRight transition-all fixed right-0 top-0 h-full z-40 shadow-lg bg-white flex justify-start items-start flex-col p-4 w-full md:w-2/5 xl:w-1/3 lg:1/5">
            <slot name="rightMenuContent"></slot>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
//import * as Routing from '@/router/Routing'

export default defineComponent({
    name: "Sirit Right Menu",
    emit: ['closeRightMenuContent'],
    setup (props, { emit }) {
        function changeContentState () {
            emit('closeRightMenuContent')
        }

        return {
            changeContentState,
            //Routing
        }
    }
})
</script>

<style lang="scss">
@keyframes fadeInRight {
    from {
        opacity: 0;
        transform: translate3d(100%, 0, 0);
    }

    to {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }
}

.fadeInRight {
    animation-name: fadeInRight;
    animation-duration: 0.5s;
}
</style>
